
import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_COMMUNITY_CONTRACT_LIST: {
        url: "gebruiker/get-communitycontract-list",
        method: "get",
    },

    ADMIN_LIST: {
        url: "gebruiker/get-admins-list",
        method: "post",
    },

    CHECK_OR_CREATE_BSN: {
        url: "checkOrCreateBSN",
        method: "post",
    },
    AVAILABILITY_LOG: {
        url: "availability/logs",
        method: "get",
    },

    GENERATE_BSN: {
        url: "generateBSN",
        method: "get",
    },
    UNCHECK_COMMUNITY: (communityId, type, iAdminId) => ({
        url: `${iAdminId ? "gebruiker/" : ""}availability/${communityId}/edit?type=${type}${iAdminId ? `&iAdminId=${iAdminId}` : ""}`,
        method: "get",
    }),


};

export const useCommunityContractList = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_COMMUNITY_CONTRACT_LIST);

export const useAdminList = () =>
    useApiFetcherSWR(API_ENDPOINT.ADMIN_LIST);

export const useCheckOrCreateBSN = () =>
    useApiFetcherSWR(API_ENDPOINT.CHECK_OR_CREATE_BSN);

export const useAvailabilityLog = (
    communityId = "all",
    pageNumber = 1,
    pageSizeCount = 10,
    searchValue = "",
    shouldFetch = true
) => {
    const params = new URLSearchParams();

    if (communityId && communityId !== "all") {
        params.append("search", communityId);
    }

    if (pageNumber) {
        params.append("page", pageNumber);
    }

    if (pageSizeCount) {
        params.append("pageSize", pageSizeCount);
    }

    if (searchValue) {
        params.append("searchValue", searchValue);
    }

    return useApiFetcherSWR(
        shouldFetch
            ? {
                ...API_ENDPOINT.AVAILABILITY_LOG,
                url: `availability/logs?${params.toString()}`,
            }
            : null
    );
};

export const useGenerateBSN = () =>
    useApiFetcherSWR(API_ENDPOINT.GENERATE_BSN);

export const useUncheckCommunity = (
    communityId,
    type,
    iAdminId,
    shouldFetch
) =>
    useApiFetcherSWR(
        shouldFetch
            ? API_ENDPOINT.UNCHECK_COMMUNITY(communityId, type, iAdminId)
            : null
    );